import { BrowserRouter, HashRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "src/components/shared/ScrollToTop";
import AppRoutes from "src/routes/AppRoutes";
import "src/globals.css";
import { WorkspaceSwitchingProvider } from "src/context/WorkspaceSwitchingContext";

const Layout = () => {
  const is_extension = window.location.protocol === "chrome-extension:";
  const Router = is_extension ? HashRouter : BrowserRouter;

  return (
    <Router>
      <div className="flex h-screen flex-col">
        <ScrollToTop />
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <WorkspaceSwitchingProvider>
          <AppRoutes />
        </WorkspaceSwitchingProvider>
      </div>
    </Router>
  );
};

export default Layout;
